import React from 'react'
import './OptionsProductDesactivate.scss'
import { Link } from 'react-router-dom'
import { firstCharCapitalize } from '../utils/utils'

export const OptionsProductDesactivate = () => {
    return (
        <div className="options-product-desactivate-container" >
            <div className="register">
                <div className="text">
                    <p>Registra tu empresa y realiza</p>
                    <p>un presupuesto online</p>
                </div>
                <div className="buttons">
                    <div className="btn">
                        <Link to="/acceso">{firstCharCapitalize('Registrate aquí')}</Link>
                    </div>
                </div>
            </div>
            <div className="contact">
                <p>Si eres un particular, <Link to="/contacto">contacta</Link> con</p>
                <p>nosotros para saber como obtener</p>
                <p>nuestros productos</p>
                <p className="contactanos"><Link to="/contacto">¡Contáctanos!</Link></p>
            </div>
        </div>
    )
}

